<template>
    <div>
        <router-view></router-view>
        <alarm-flash-overlay v-if="hasAlarmsFeature"></alarm-flash-overlay>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AlarmFlashOverlay from '@/components/Alarm/AlarmFlashOverlay'

export default {
  name: 'App',
  components: {
    'alarm-flash-overlay': AlarmFlashOverlay
  },
  computed: {
    ...mapGetters({
      hasAlarmsFeature: 'hasAlarmsFeature'
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue